import { CloseIcon } from "@chakra-ui/icons";
import { Box, Flex, Grid, Image, Text } from "@chakra-ui/react";
import DefaultImage from "@assets/images/ChatSourceDefaultImage.svg";
import { StartNewChat } from "@root/assets/icons/startNewChat";
import { useTranslation } from "react-i18next";
import { NewTabIcon } from "@root/assets/icons/NewTabIcon";
import { useMainChatContext } from "@root/context/kps-chat-context";
import { useEffect } from "react";
import { FileIcon } from "@root/assets/icons/file-icon";
import LinkIcon from "@root/assets/icons/linkicon";
import { ChevronRightIcon } from "@chakra-ui/icons";

export const sources = [
  {
    url: "https://example.com/resource1",
    title: "Introduction to Chemical Safety",
    content: "An overview of safety protocols in chemistry labs.",
    metadata: {
      favicon: "",
    },
  },
  {
    url: "https://example.com/resource2",
    title: "Fire Hazard Procedures",
    content: "How to handle fire-related emergencies in laboratories.",
    metadata: {
      favicon: "",
    },
  },
  {
    url: "https://example.com/resource3",
    title: "Personal Protective Equipment",
    content: "Types and proper use of lab safety gear.",
    metadata: {
      favicon: "",
    },
  },
  {
    url: "https://example.com/resource4",
    title: "Emergency Exit Maps",
    content: "Evacuation plans and safety signage explained.",
    metadata: {
      favicon: "",
    },
  },
  {
    url: "https://example.com/resource5",
    title: "Spill Response Guidelines",
    content: "Steps to take when hazardous substances spill.",
    metadata: {
      favicon: "",
    },
  },
  {
    url: "https://example.com/resource6",
    title: "Lab Equipment Handling",
    content: "Safe use and maintenance of common lab tools.",
    metadata: {
      favicon: "",
    },
  },
  {
    url: "https://example.com/resource7",
    title: "Incident Reporting",
    content: "How to report lab accidents and near misses.",
    metadata: {
      favicon: "",
    },
  },
];

const ChatSourceData = ({
  onClose,
  sources,
}: {
  onClose?: () => void;
  sources: any;
}) => {
  const { setSourcesData } = useMainChatContext();
  const { t } = useTranslation("common");

  function handlePreviewClick(source: any) {
    if (typeof source === "object") {
      window.open(source?.signedUrl, "_blank");
    } else {
      window.open(source, "_blank");
    }
  }

  function renderSources() {
    return (
      <Grid templateColumns="repeat(4, 1fr)" gap="20px">
        {sources?.slice(0, 3)?.map((source: any, index: any) => (
          <Flex
            key={index}
            border="1px solid"
            borderColor="#F2F2F2"
            borderRadius="16px"
            p="10px 16px"
            flexDir="column"
            gap="10px"
            cursor={"pointer"}
            onClick={() => handlePreviewClick(source)}
            height="100%"
          >
            <Flex gap="5px" flexDirection={"column"}>
              <Flex flexDirection={"row"} justifyContent={"space-between"}>
                <LinkIcon />
                <Flex gap="8px" alignItems="center" cursor="pointer">
                  <NewTabIcon />
                </Flex>
              </Flex>
              <Flex>
                <Text
                  color="#111827"
                  fontWeight={600}
                  fontSize="16px"
                  marginBottom="5px"
                  marginTop="2px"
                  isTruncated
                  maxW={"300px"}
                >
                  {source?.file_name}
                </Text>
              </Flex>
            </Flex>
          </Flex>
        ))}
        <Flex
          border="1px solid"
          fontSize={"15px"}
          borderColor="#F2F2F2"
          borderRadius="16px"
          p="16px"
          justifyContent={"center"}
          alignItems={"center"}
          cursor={"pointer"}
          height="100%"
          onClick={() => setSourcesData(sources)}
          gap={"4px"}
        >
          <Text fontWeight={500} color={"#40599B"}>
            {`${t("translate.viewSource")}`}
          </Text>
          <ChevronRightIcon color={"#40599B"} fontSize={20} />
        </Flex>
      </Grid>
    );
  }

  return (
    <Box>
      <Flex justifyContent={"space-between"}>
        <Text fontWeight={"600"} fontSize={"16px"}>
          {t("translate.sources")}
        </Text>
      </Flex>

      <Flex mt={"12px"} flexDirection={"column"} gap={"15px"}>
        {renderSources()}
      </Flex>
    </Box>
  );
};

export default ChatSourceData;
